import React, {useEffect, useRef, type PropsWithChildren, type FC, type TouchEvent} from 'react'

export const PreventPullToRefresh: FC<PropsWithChildren> = ({ children }) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    let startY: number | null = null

    const isScrollable = (element: HTMLElement): boolean => {
      const style = window.getComputedStyle(element);
      const overflowY = style.overflowY;
      const canScroll = overflowY === "auto" || overflowY === "scroll"
      return canScroll && element.scrollHeight > element.clientHeight
    };
    
    // verifica se o evento pode ser bloqueado no elemento alvo.
    const shouldPreventPullToRefresh = (target: HTMLElement): boolean => {
      let currentElement: HTMLElement | null = target;

      while (currentElement !== null && currentElement !== document.body) {
        if (isScrollable(currentElement)) {
          return false
        }
        currentElement = currentElement.parentElement
      }

      return true
    }

    const handleTouchStart = (ev: TouchEvent) => {
      startY = ev.touches[0].clientY
    }

    const handleTouchMove = (ev: TouchEvent) => {
      const currentY = ev.touches[0].clientY
      const deltaY = startY !== null ? currentY - startY : 0

      const target = ev.target as HTMLElement
      if (window.scrollY <= 0 && deltaY > 0 && shouldPreventPullToRefresh(target)) {
        ev.preventDefault()
      }
      return
    }

    // @ts-expect-error ts(2769)
    document.addEventListener('touchstart', handleTouchStart, { passive: false })
    // @ts-expect-error ts(2769)
    document.addEventListener('touchmove', handleTouchMove, { passive: false })

    return () => {
      // @ts-expect-error ts(2769)
      document.removeEventListener('touchstart', handleTouchStart)
      // @ts-expect-error ts(2769)
      document.removeEventListener('touchmove', handleTouchMove)
    };
  }, []);

  return (
    <div style={{ height: '100%', width: '100%' }} ref={ref}>
      {children}
    </div>
  )
}
